import { Component } from '@angular/core';

@Component({
	selector: 'sgp-skeleton-cadastrar-edital',
	templateUrl: './skeleton-cadastrar-edital.component.html'
})
export class SkeletonCadastrarEditalComponent {}
